module.exports = __webpack_public_path__ + "static/painting-kaang-chin-woman-55c673f09bcbb7b8dc01325c9d15f652.jpg";